import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Conversations({ conversations = [], setConversations }) {
  const [numParticipants, setNumParticipants] = useState(1);
  const [conversationId, setConversationId] = useState('');
  const [participants, setParticipants] = useState(5); // Example number of participants

  const navigate = useNavigate();
  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');
  
  const handleParticipantsChange = (event) => {
    setParticipants(Number(event.target.value));
  };

  const createConversation = async () => {
    try {
      const response = await fetch('create-conversation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ numParticipants: numParticipants })
      });

      if (!response.ok) {
        throw new Error('Create conversation failed');
      }

      const data = await response.json();
      const id = data.convID;
      const participants = data.numParticipants;
      console.log(data);
      console.log(id);
      console.log(participants);
      setConversationId(id); // Update the state with the new conversation ID
      setConversations([...conversations, { id, participants }]);
      //navigate(`/conversation/${id}`);
    } catch (error) {
      console.error('Error creating conversation:', error);
    }
  };

  return (
    <div>
      <h1>Conversations Overview</h1>
      <button onClick={createConversation}>Create New Conversation</button>
      <select value={numParticipants} onChange={(e) => setNumParticipants(Number(e.target.value))}>
        {[...Array(10).keys()].map((i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </select>
      <input type="text" value={conversationId} readOnly /> {/* Textbox to display the conversation ID */}
      <ul>
        {conversations.map((conv) => (
          <li key={conv.id}>
            <Link to={`/conversation/${conv.id}`}>{conv.id}</Link>
            <ul>
              {[...Array(conv.participants || 0).keys()].map((i) => (
                <li key={`${conv.id}-participant-${alphabet[i]}`}>
                  <Link to={`/conversation/${conv.id}/${alphabet[i]}`}>
                    Participant {alphabet[i]}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Conversations;